<template>
  <div class="msgtypeLink">
    <a :href="items.content.link_url" target="_blank">
      {{ items.content.link_url }}
    </a>
  </div>
</template>

<script>
export default {
  name: '',
  props: {
    items: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {};
  },
};
</script>

<style scoped lang="scss">
.msgtypeLink {
  padding: 0 12px;
  box-sizing: border-box;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 80%;
  a {
    font-size: 14px;
    letter-spacing: 0;
    line-height: 16px;

    line-height: 24px;
  }
}
</style>
